import { useAtomValue, useSetAtom } from '~shared/lib/atom-state';

import {
  parentVoucherNotificationsAtom,
  parentVoucherNotificationsLoadingAtom,
  parentVoucherNotificationsUnreadCountAtom,
  refetchParentVoucherNotificationsUnreadCountAtom,
  setParentVoucherNotificationsAtom,
} from './atoms';

export const useParentVoucherNotifications = () => useAtomValue(parentVoucherNotificationsAtom);
export const useParentVoucherNotificationsLoading = () =>
  useAtomValue(parentVoucherNotificationsLoadingAtom);
export const useSetParentVoucherNotifications = () => useSetAtom(setParentVoucherNotificationsAtom);

export const useParentVoucherNotificationsUnreadCount = () =>
  useAtomValue(parentVoucherNotificationsUnreadCountAtom);
export const useRefetchParentVoucherNotificationsUnreadCount = () =>
  useSetAtom(refetchParentVoucherNotificationsUnreadCountAtom);
